import { Box, Typography } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

function Footer() {
  return (
    <Box p={2} gap={1} display="flex" flexDirection={{ xs: "column", sm: "row" }} justifyContent="space-around" alignItems="center">
      <Box>
        <Typography variant="caption" sx={{ fontSize: "11px", color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }}>
          Property of RotoGPT, LLC, Company 2025 - All Rights Reserved.
        </Typography>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="center" gap={2}>
        <Typography
          variant="caption"
          component="a"
          href="https://www.rotogpt.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ textDecoration: "underline", cursor: "pointer", fontSize: "11px", color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }}
        >
          Privacy Policy
        </Typography>
        <Typography
          variant="caption"
          component="a"
          href="https://www.rotogpt.com/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ textDecoration: "underline", cursor: "pointer", fontSize: "11px", color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }}
        >
          Terms of Service
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
